import '../assets/css/colors.css'
import '../assets/css/Principais.css'
import '../assets/css/fonts.css'
import '../assets/css/topMenu.css'
import { useNavigate } from 'react-router-dom'

import { useEffect, useState } from 'react'



//logoAnimation
export default function TopMenu(props){

    const [ativaResp, setAtivaResp] = useState(null)
    const [showLateralMenu, setShowLateralMenu] = useState('inicial')

    const navigate = useNavigate()

    useEffect(()=>{
        if (ativaResp == null){
            if (window.matchMedia("(max-width: 767px)").matches){
            setAtivaResp(true)
            }else{
                setAtivaResp(false)
            }
        }
    },[ativaResp])

    return <>
    
            <div className="topMenu" style={{position: "relative", opacity: 0}}></div>
            <div className="topMenu">

                <div className="logoTop"></div>
                <div className="btnsTop">
                    {/* {ativaResp ? <div className="sideMenuBtn" onClick={()=>setShowLateralMenu(showLateralMenu === 'inicial' ? true : !showLateralMenu)}></div>
                            :
                    <>
                         <div className="itemTopMenu">INICIO</div>
                        <div className="itemTopMenu">LOJAS</div>
                        <div className="itemTopMenu">VANTAGENS</div>
                        <div className="itemTopMenu">TRABALHE CONOSCO</div> 
                    </>} */}
                </div>
            </div>

            {/* {ativaResp ? <div className={`lateralMenu  ${showLateralMenu === 'inicial' ? 'lateralMenuInicial' : showLateralMenu ? "mostraMenuLateral" : "escondeMenuLateral"}`}>
                    

                    <div className="topLateralMenu">
                        <div className="logo"></div>
                        <div className='menuCloseBtn' onClick={()=>setShowLateralMenu(false)}></div>
                    </div>

                    <div className="lateralMenuRedirect">
                        <div className="itemLateralMenu">INICIO</div>
                        <div className="itemLateralMenu">LOJAS</div>
                        <div className="itemLateralMenu">VANTAGENS</div>
                        <div className="itemLateralMenu">TRABALHE CONOSCO</div>
                    </div>
                    

                    </div> : <></>} */}
            
    </>

}